module.exports = __webpack_public_path__ + "media/non specific colitis.00fc73cb.wav";